import src from "IMAGE";
export default { src, width: 1007, height: 261, blurWidth: 0, blurHeight: 0};
